// Stable digest of the StoryIdea prompt-inputs a verdict was generated
// against (title + news_hook + topics). The AI vet judges journalist
// fit *for these inputs*, so a verdict is only meaningful relative to
// them — comparing the current inputs' digest to the one captured at
// vet time is how the picker detects stale verdicts.
//
// v1 needs equality only (mark-stale on any change); the staleness
// fast-follow upgrades this to storing the raw text for word-level
// diffing + a magnitude heuristic.
//
// Normalised so cosmetic edits don't trip staleness: title + news_hook
// trimmed and lower-cased; topics trimmed, lower-cased, and sorted so
// reordering them is a no-op. A newline-delimited separator between the
// fields avoids collisions (e.g. a title ending where a hook begins).
export default function digestStoryIdea(storyIdea) {
  if (!storyIdea) return "";
  const title = (storyIdea.title || "").trim().toLowerCase();
  const newsHook = (storyIdea.news_hook || "").trim().toLowerCase();
  const topics = [...(storyIdea.topics || [])]
    .map((t) => String(t).trim().toLowerCase())
    .sort()
    .join("\n");
  return [title, newsHook, topics].join("\n::\n");
}
